import { Link } from 'react-scroll';

const callItems = [
  {
    icon: 'ri-search-eye-line',
    title: 'How Customers Are Finding You (Or Not)',
    desc: 'We\'ll break down exactly how people in your area are searching for your type of business — and whether you\'re showing up.',
  },
  {
    icon: 'ri-error-warning-line',
    title: 'Where You\'re Losing Potential Leads',
    desc: 'We\'ll identify the specific gaps in your current setup that are costing you calls, form fills, and paying customers.',
  },
  {
    icon: 'ri-route-line',
    title: 'A Simple System to Generate Consistent Customers',
    desc: 'We\'ll walk you through a straightforward approach to bringing in inbound customers on a predictable, ongoing basis.',
  },
  {
    icon: 'ri-question-answer-line',
    title: 'Answers to Any Questions You Have',
    desc: 'No pitch deck, no pressure. Just an honest conversation about what\'s working, what isn\'t, and how to fix it.',
  },
];

const OfferSection = () => (
  <section id="offer" className="bg-[#f8f9fa] py-24 md:py-32">
    <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
      <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">No Fluff. No Pressure.</span>
      <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
        Book a Free Strategy Call
      </h2>
      <p className="text-gray-500 text-lg max-w-2xl mx-auto mb-14">
        A direct, no-nonsense conversation about your business. We'll cover what matters and skip everything that doesn't.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14 text-left">
        {callItems.map((item) => (
          <div key={item.title} className="bg-white rounded-2xl p-8 border border-gray-100">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-50 mb-5">
              <i className={`${item.icon} text-orange-500 text-2xl`} />
            </div>
            <h3 className="text-gray-900 font-bold text-lg mb-2">{item.title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>

      <Link
        to="form"
        smooth
        duration={500}
        offset={-80}
        className="whitespace-nowrap cursor-pointer inline-block px-10 py-5 bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg rounded-xl transition-all"
      >
        Book a Strategy Call
      </Link>
      <p className="text-gray-400 text-sm mt-4">Takes less than 2 minutes to request. No obligation whatsoever.</p>
    </div>
  </section>
);

export default OfferSection;
